
const APIURL = "https://app.endycahyono.com/first/firstmedia/v4";

const api = {

    async getChannel() {
        let url = APIURL + '/channel';
        let response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({})
        });
        let obj = await response.json();
        return obj;
    },

    async getSchedule(channelNumbers, dateStart, dateEnd) {
        let url = APIURL + '/schedule';
        let response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                ChannelNumbers: channelNumbers,
                DateStart: dateStart,
                DateEnd: dateEnd
            })
        });
        let obj = await response.json();
        return obj;
    }

}

export default api;
